module.exports = __webpack_public_path__ + "ec947ac6265d6a782c889ee205101650.svg";